import { createApi } from '@reduxjs/toolkit/query/react';
import { APP_CONTEXT_API } from 'services/constants';
import { rawBaseQuery } from 'services/shared';
import { ContextResponse } from 'services/types';

export const contextsApi = createApi({
  reducerPath: APP_CONTEXT_API,
  baseQuery: rawBaseQuery,
  endpoints: (builder) => ({
    getContexts: builder.query<ContextResponse[], void>({
      query: () => encodeURI(`/contexts`),
    }),
  }),
});

export const { useGetContextsQuery } = contextsApi;
